// extracted by mini-css-extract-plugin
export default {"nav":"Id3wzSqb","top":"iU9NE6Z4","content":"aFjJgOOJ","footer":"fhJxopeQ"};